export const msGraphKeys = {
  all: ['msGraph'] as const,
  driveItem: () => [...msGraphKeys.all, 'driveItem'] as const,
  getDriveItemFromUrl: (fileUrl?: string) => [...msGraphKeys.driveItem(), fileUrl] as const
};
